export const NOTE = 'NOTE';
export const IFRAME = 'IFRAME';
export const SECTION_HEADER = 'SECTION_HEADER';